import React from 'react';
import useVirtualTourAvailabilities from '../../components/listing/useVirtualTourAvailabilities';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import {
  LISTING_PREVIEW_VARIANTS,
  LISTING_VIEWER_VARIANTS,
} from './ListingImageGallery/imageHelpers';

import css from './ListingPage.module.css';
import { DEFAULT_IMAGE_VARIANT } from '../../util/enums';

const SectionGallery = props => {
  const { listing, isListingPage, viewport } = props;
  const images = listing.images;
  const listingId = listing?.id?.uuid || listing?.id;
  const virtualTourAvailability = useVirtualTourAvailabilities(listingId ? [listing] : []);
  const hasVirtualTour = virtualTourAvailability[listingId] === true;

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={LISTING_PREVIEW_VARIANTS}
        thumbnailVariants={[DEFAULT_IMAGE_VARIANT]}
        previewVariants={LISTING_VIEWER_VARIANTS}
        isListingPage={isListingPage}
        viewport={viewport}
        hasVirtualTour={hasVirtualTour}
      />
    </section>
  );
};

export default SectionGallery;
